import React from 'react';

import {useSelector} from 'react-redux';

import {PRIMER_PAYMENT_METHODS} from 'constants/paymentMethods';
import {PAYMENTS} from 'desktop/pages/checkout/constants/paymentStep';
import {getPaymentMethods} from 'desktop/pages/checkout/store/selectors/paymentStep/paymentStep';

import {getPrimerState} from 'desktop/pages/checkout/store/selectors/primer/primer';

import {PaymentMethodOneStep} from './paymentMethodOneStep/paymentMethodOneStep';

type FilteredPrimerMethodsType = {
    selectedPaymentMethod: string;
    setSelectedPaymentMethod: React.Dispatch<React.SetStateAction<string>>;
};

/**
 * useFilteredPrimerMethods hook for one step
 */
export const useFilteredPrimerMethods = ({
    selectedPaymentMethod,
    setSelectedPaymentMethod,
}: FilteredPrimerMethodsType) => {
    const availableMethods = useSelector(getPaymentMethods);
    const primerState = useSelector(getPrimerState);

    const methodKeys = Object.keys(availableMethods.list).sort(
        (prev, current) =>
            Number(availableMethods.list[prev as PAYMENTS]?.order) -
            Number(availableMethods.list[current as PAYMENTS]?.order),
    );

    return methodKeys
        .filter(payment => {
            if (payment === PAYMENTS.METHOD_PRIMER_VENMO) return false;
            if (!primerState.isApplePayAvailable && payment === PAYMENTS.METHOD_PRIMER_APPLE_PAY)
                return false;
            return PRIMER_PAYMENT_METHODS.includes(payment as PAYMENTS);
        })
        .map(payment => (
            <PaymentMethodOneStep
                key={payment}
                paymentKey={payment as PAYMENTS}
                selectedPaymentMethod={selectedPaymentMethod}
                setSelectedPaymentMethod={setSelectedPaymentMethod}
            />
        ));
};
